import { Country } from '@app/domain/models/country.model';

/**
 * Forma cruda de cada país tal como viene en `assets/data/countries.json`
 * (estructura derivada de la API REST Countries). Tipado explícito en lugar
 * de `any` para respetar el strict mode del proyecto.
 */
export interface CountryDto {
  name: { common: string };
  /** ISO 3166-1 alfa-2 (lo agrega `scripts/agregar-codigo-iso-paises.mjs`, SUITE-024). */
  cca2?: unknown;
  flags: { svg: string };
  idd: { root: string; suffixes?: string[] };
}

const ISO2 = /^[A-Z]{2}$/;

/** Transforma el DTO crudo en la entidad de dominio que consume la UI. */
export function mapCountryDtoToDomain(dto: CountryDto): Country {
  const suffix = dto.idd.suffixes?.[0] ?? '';
  const code = typeof dto.cca2 === 'string' && ISO2.test(dto.cca2.trim()) ? dto.cca2.trim() : null;
  return {
    name: dto.name.common,
    svg: dto.flags.svg,
    dialCode: `${dto.idd.root}${suffix}`,
    code,
  };
}
